CDN.requireOnce([
    { code: CDN.PackageCode.Common, },
    { code: CDN.PackageCode.Control_UI_TimePicker, },
    { code: CDN.PackageCode.Control_UI_DateTimePicker, },
    { code: CDN.PackageCode.Control_UI_MonthPicker, },
    { code: CDN.PackageCode.Control_UI_ToggleSwitch, },
], () => {
    let style = document.createElement("style");
    style.innerHTML = `
        .cdn-control-ui-testdiv {
            margin-bottom: 10px;
        }
    `;
    document.head.appendChild(style);

    let showHeadings = false;

    function addHeading(label: string) {
        if (!showHeadings) return;

        let lblDiv = document.createElement('div');
        lblDiv.innerHTML = label;
        exibitA.appendChild(lblDiv);
    }

    let displayCase = document.createElement('div');
    let displayCaseInner = document.createElement('div');
    displayCase.appendChild(displayCaseInner);
    displayCase.style.display = 'flex';
    displayCase.style.alignItems = 'center';
    displayCase.style.justifyContent = 'space-around';
    displayCaseInner.style.display = 'flex';
    displayCaseInner.style.flexDirection = 'column';
    displayCaseInner.style.flexWrap = 'wrap';
    let exibitA = document.createElement('div');
    let exibitB = document.createElement('div');
    exibitA.style.padding = '60px';
    exibitB.style.padding = '60px';

    displayCaseInner.appendChild(exibitA);
    //displayCaseInner.appendChild(exibitB);
    document.querySelector('main').appendChild(displayCase);

    DateTimePickerInputTest(exibitA);

    //DateTimeRangePickerTest(exibitB);

    function TimePickerTest(container: HTMLElement) {
        addHeading("TimePicker");

        let timePickerDiv = document.createElement("div");
        container.appendChild(timePickerDiv);
        timePickerDiv.className = "cdn-control-ui-testdiv";

        let timePicker = new CDN.Controls.UI.DateTime.TimePicker(timePickerDiv, {
            hour: {
                label: 'h',
                show: true,
                step: 1,
                value: 2,
            },
            minute: {
                label: 'm',
                show: true,
                step: 5,
            },
            second: {
                show: false,
            },
        });
    }

    function DateTimeRangePickerTest(container: HTMLElement) {
        addHeading("DateTimePicker (Range)");
        let datetimeRangePicker = new CDN.Controls.UI.DateTime.DateTimeRangePicker(container, {

        });
    }

    function DateTimePickerTest(container: HTMLElement) {
        addHeading("DateTimePicker");
        let datetimePickerV2 = new CDN.Controls.UI.DateTime.DateTimePicker(container, {
            from: new Date().addMonths(-1).getTime(),
        });
    }

    function DateTimePickerInputTest(container: HTMLElement) {
        addHeading("DateTimePicker Input");

        let aaLbl = document.createElement('div');
        aaLbl.innerHTML = 'Auto Advance';
        aaLbl.style.marginRight = '10px';
        let autoAdvance = new CDN.Controls.UI.ToggleSwitch(container, {
            label: aaLbl,
            callback: (on) => {
                datetimePickerInputV2.autoAdvance = on;
            },
            default: true,
        });
        autoAdvance.container.style.display = 'block';
        autoAdvance.container.style.width = '200px';

        let secLbl = document.createElement('div');
        secLbl.innerHTML = 'Show Second';
        secLbl.style.marginRight = '10px';
        let showSecond = new CDN.Controls.UI.ToggleSwitch(container, {
            label: secLbl,
            callback: (on) => {
                datetimePickerInputV2.showSecond = on;
            },
            default: false,
        });
        showSecond.container.style.display = 'block';
        showSecond.container.style.width = '200px';

        let anLbl = document.createElement('div');
        anLbl.innerHTML = 'Allow Null';
        anLbl.style.marginRight = '10px';
        let allowNull = new CDN.Controls.UI.ToggleSwitch(container, {
            label: anLbl,
            callback: (on) => {
                //datetimePickerInputV2.allowNull = on;
            },
            default: true,
        });
        allowNull.container.style.display = 'block';
        allowNull.container.style.width = '200px';
        allowNull.container.style.marginBottom = '20px';

        let datetimePickerInputV2 = new CDN.Controls.UI.DateTime.DateTimePickerInput(container, {
            autoAdvance: autoAdvance.value,
            showSecond: showSecond.value,
            allowNull: allowNull.value,
            from: new Date().addMonths(-2).getTime(),
        });
        datetimePickerInputV2.container.style.width = '200px';

    }

    /*
    let monthPickerDiv = document.createElement("div");
    body.appendChild(monthPickerDiv);
    monthPickerDiv.className = "cdn-control-ui-testdiv";
    let monthPicker = new CDN.Controls.UI.DateTime.MonthPickerInput(monthPickerDiv, {
        from: new Date().addYears(- 5),
        to: new Date(),
        default: new Date(),
    });

    let monthRangePickerDiv = document.createElement("div");
    body.appendChild(monthRangePickerDiv);
    monthRangePickerDiv.className = "cdn-control-ui-testdiv";
    let monthRangePicker = new CDN.Controls.UI.DateTime.MonthRangePicker(monthRangePickerDiv, {
        from: new Date().addMonths(-12),
        to: new Date(),
        onSelect: (fromYear, fromMonth, toYear, toMonth) => {
            outputDiv.innerHTML = `Output: ${CDN.Common.monthNames[fromMonth]} ${fromYear} to ${CDN.Common.monthNames[toMonth]} ${toYear}`;
        }
    });
    */

    //let outputDiv = document.createElement("div");
    //outputDiv.style.marginBottom = '100px';
    //outputDiv.innerHTML = "Output: ";
    //body.appendChild(outputDiv);
    //let output = document.createElement("span");
    //outputDiv.appendChild(output);
    //outputDiv.className = "cdn-control-ui-testdiv";

});